import { useGate } from 'statsig-react';
import { FEATURE_GATES } from '@utils/constants';

export function useNewMobileNav() {
  const { value } = useGate(FEATURE_GATES.NEW_MOBILE_NAV);

  return { enableNewMobileNav: value };
}
